import { useState } from "react";
import { AppBar, Toolbar, IconButton } from "@material-ui/core";
import MenuIcon from "@material-ui/icons/Menu";
import NavigationDrawer from "./nav_drawer/NavigationDrawer";
import cocLogo from "../../images/cosmos-offer-club-logo.png";
import useStyles from "./styles";

function Header() {
  const [displayNavigationBar, setDisplayNavigationBar] = useState(false);
  const classes = useStyles();

  return (
    <>
      <div className={classes.appBarContainer}>
        <AppBar className={classes.appBar} position="static">
          <Toolbar>
            <IconButton
              edge="start"
              onClick={() => setDisplayNavigationBar(true)}
            >
              <MenuIcon />
            </IconButton>
            <div className={classes.websiteLogoContainer}>
              <img src={cocLogo} alt="" className={classes.webisteLogo}/>
            </div>
          </Toolbar>
        </AppBar>
      </div>
      <NavigationDrawer
        open={displayNavigationBar}
        onClose={() => setDisplayNavigationBar(false)}
      />
    </>
  );
}

export default Header;
